import Auth from '@aws-amplify/auth';

/**
 * Gets an access token for the currently authenticated user, or undefined if there is not a valid user session.
 * Refreshes the access token if the current one is expired.
 */
export const getAccessToken = async (): Promise<string | undefined> => {
  try {
    // This will automatically refresh the accessToken and idToken if they are expired
    // and the refreshToken is a valid. Otherwise it will return the cached tokens.
    const session = await Auth.currentSession();
    return session.getIdToken().getJwtToken();
  } catch (e) {
    return undefined;
  }
};
